import { LoadingService } from '../../../shared/services/loading.service';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { CollateralService } from '../../../setup/services/collateral.service';
import { CustomerService } from '../../../customer/services/customer.service';
import { Subject } from 'rxjs';
import {CollateralType } from '../../../shared/constant/app.constant';
import { saveAs } from 'file-saver';

@Component({
  selector: 'collateral-information-view',
  templateUrl: './collateral-information-view.component.html',
})
export class CollateralInformationViewComponent implements OnInit {
  myDocExtention: any;
  pdfFileName: any;
  pdfFile: any;
  insurancePolicies: any;
  supportingDocuments: any;
  binaryFile: string;
  imageData: any;
  selectedDocument: string;
  displayDocument: boolean = false;
  myPdfFile: any;
  collateralId:any;
  toSearchBtnText: string;
  customerCollateralSelection: any;
  customers: any;
  collateralItemPolicy: any;
  collateralItemDomicilliationContract: boolean = false;
  collateralItemDomicilliationSalary: boolean = false;
  collateralIndemnity: any;
  collateralPromissory: any;
  collateralOthers: any;
  collateralISPO: any;
  hasInsurance: any;
  collateralDeposit: any;
  collateralCasa: any;
  collateralPreciousMetal: any;
  collateralStock: any;
  collateralVehicle: any;
  collateralEquipment: any;
  customerName: any;
  collateralGaurantee: any;
  collateralMarketableSecurity: any;
  collateralInsurancePolicy: any;
  collateralProperty: any;
  mainCollateralView:any;
  customerCollateral: any;
  searchResults: any[];
  searchTerm$ = new Subject<any>();
  searchStagingTerm$ = new Subject<any>();
  hideTable:boolean=true;
  hideGrid:boolean=false;
  mainCollateralDetail : any={};
  isInsurancePolicy:any;
  isVisitation:any;
  personal = false;
  corporate = false;
  collateralVisitation: any;
  @Input() isHeaderInfoBased: boolean = true;
  @Input() showCollateralInformation = false;
  @Input() collateralCustomerId: number;
  @Input() useSearch: boolean = true;
  @Input() collateralTypeId: number;
  @Input('searchQuery') searchQuery = new Subject<string>();
  @Output() closeWindow = new EventEmitter<boolean>();
  @Input() jobReply = false;

  
  
  @Output() selectedCaollateral: any;
  customerCollaterals: any[];
  comment:any;
  approvalStatusId:any;
    isLegal: boolean;
    constructor(
    private collateralService: CollateralService,
    private loadingService: LoadingService,
    private customerService: CustomerService,
  ) {  }

  ngOnInit() {
    ////console.log('collateralId',this.collateralCustomerId);
    this.getTempCustomerCollateral();
   
  }

  @Input() set reload(value: number) {

      ////console.log("value", value);
      if(value != NaN || value != undefined || value != null)
    if (value > 0) this.getTempCustomerCollateral(); }

  getTempCustomerCollateral( ): void {
   // this.loadingService.show();
 
   ////console.log('this.collateralCustomerId',this.collateralCustomerId);
   
    this.collateralService.getCustomerCollateralByCollaterId(this.collateralCustomerId).subscribe((response: any) => {
      this.customerCollaterals = response.result;
           
    }, (err) => {
        this.loadingService.hide(1000);
    });
}

getTempCollateralByType(collateralId, typeId): void {
  this.loadingService.show();
  this.collateralService.getTempCollateralInformationByCollateralType(collateralId, typeId).subscribe((response: any) => {
      this.selectedCaollateral = response.result;

      ////console.log('sub items...', response);
      this.loadingService.hide();
  }, (err) => {
      this.loadingService.hide(1000);
  });
}

closeCollateralDetails() {
    this.closeWindow.emit(true);
}

public getCollateralInformation(collateralCustomerId: number, collateralTypeId: number): any {

    ////console.log('collateralCustomerId <> ',collateralCustomerId);
    ////console.log('collateralTypeId <> ',collateralTypeId);
    
  
  this.collateralService.getCollateralInformationByCollateralType(collateralCustomerId,collateralTypeId)
          .subscribe((res: any) => {
            
            // if (res.result == null) {
            //     swal(GlobalConfig.APPLICATION_NAME, 'The details for this collateral have not been captured', 'warning');
            //     return;
            // }
            this.customerCollateral = res.result;

            console.log('customerCollateral',res.result);
            console.log('this.mainCollateralDetail',this.mainCollateralDetail);
            ////console.log('this.customerCollaterals <<>>',this.customerCollaterals);
            

            if(this.customerCollaterals!=null)
            {this.mainCollateralDetail = this.customerCollaterals.find(x=>x.collateralId == collateralCustomerId) }


             this.isInsurancePolicy = this.mainCollateralDetail.requireInsurancePolicy;
              this.isVisitation = this.mainCollateralDetail.requireVisitation;
              this.collateralId = this.mainCollateralDetail.collateralId;
             this.customerName = this.mainCollateralDetail.customerName;

              if(this.mainCollateralDetail.collateralTypeId == CollateralType.IMMOVABLE_PROPERTY) {this.collateralProperty =true;this.mainCollateralView=true; }
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.MARKETABLE_SECURITIES) {this.collateralMarketableSecurity =true;this.mainCollateralView=true;}
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.GUARANTEE) {this.collateralGaurantee =true;this.mainCollateralView=true;}
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.PLANT_AND_EQUIPMENT) {this.collateralEquipment = true;this.mainCollateralView=true;}
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.VEHICLE) {this.collateralVehicle =true;this.mainCollateralView=true;}
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.STOCK) {this.collateralStock=true;this.mainCollateralView=true;}
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.PRECIOUS_METAL) {this.collateralPreciousMetal=true;this.mainCollateralView=true;}
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.CASA) {this.collateralCasa =true;this.mainCollateralView=true;}
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.FIXED_DEPOSIT) {this.collateralDeposit =true;this.mainCollateralView=true;}
              if(this.mainCollateralDetail.collateralTypeId ==CollateralType.POLICY) {this.collateralItemPolicy = true;this.mainCollateralView=true;}
              if (this.mainCollateralDetail.collateralTypeId == CollateralType.DOMICILIATIONCONTACT) { this.collateralItemDomicilliationContract = true; this.mainCollateralView = true; }
              if (this.mainCollateralDetail.collateralTypeId == CollateralType.DOMICILIATIONSALARY) { this.collateralItemDomicilliationSalary = true; this.mainCollateralView = true; }
              if (this.mainCollateralDetail.collateralTypeId == CollateralType.INDEMNITY) { this.collateralIndemnity = true; this.mainCollateralView = true; }
              if (this.mainCollateralDetail.collateralTypeId == CollateralType.PROMISSORY) { this.collateralPromissory = true; this.mainCollateralView = true; }
              if (this.mainCollateralDetail.collateralTypeId == CollateralType.MISCELLANEOUS) { this.collateralOthers = true; this.mainCollateralView = true; }
              if (this.mainCollateralDetail.collateralTypeId == CollateralType.ISPO) { this.collateralISPO = true; this.mainCollateralView = true; }



            
              this.customerCollateral != null ? this.useSearch = false : this.useSearch = true;
              
              
              this.getSupportingDocuments(collateralCustomerId);
              if(this.isInsurancePolicy){
              this.getCollaterTempItemPolicies(collateralCustomerId);}
            });
            this.hideGrid=true;
            return this.customerCollateral;
}
onSlectedCustomerChange() {
  this.collateralCustomerId = this.customerCollateralSelection.collateralId;
  this.collateralTypeId = this.customerCollateralSelection.collateralTypeId;

  this.getCollateralInformation(this.collateralCustomerId,this.collateralTypeId);
}

turnOnSearch(){
  this.useSearch = true;
  this.customerCollateral = false;
  this.collateralDeposit = false;
  this.collateralCasa = false;
  this.collateralPreciousMetal= false;
  this.collateralStock = false;
  this.collateralVehicle = false;
  this.collateralEquipment = false;
  this.customerName = false;
  this.collateralGaurantee = false;
  this.collateralMarketableSecurity = false;
  this.collateralInsurancePolicy = false;
  this.collateralProperty = false;
  this.mainCollateralView = false,
  this.collateralItemDomicilliationContract = false,
  this.collateralItemDomicilliationSalary = false,
  this.collateralIndemnity = false,
  this.collateralPromissory = false,
  this.collateralOthers = false,
  this.collateralISPO = false

this.hideTable=true;



  }

  

  viewVisitationDocument(id: number) {
    this.collateralService.getCollateralVisitationFile(id).subscribe((response: any) => {
        this.imageData = response.result;

        ////console.log('documents..',  this.imageData);
    });

    let doc = this.imageData;
   // let doc = this.imageData.find(x => x.targetId == id);
    if (doc != null) {

        ////console.log('doc.fileData..',  doc.fileData);

        this.binaryFile = doc.fileData;
        this.selectedDocument = doc.documentTitle;
        this.displayDocument = true;
    }
}
viewCollateralDocument()
{
  this.collateralService.getCollateralDocument(this.collateralId).subscribe((response: any) => {
    this.imageData = response.result[0];
    ////console.log('documents..',  this.imageData);
    this.binaryFile = doc.fileData;
    this.selectedDocument = doc.documentTitle;
    this.displayDocument = true;
});

let doc = this.imageData;
// let doc = this.imageData.find(x => x.targetId == id);
if (doc != null) {

    ////console.log('doc.fileData..',  doc.fileData);

    this.binaryFile = doc.fileData;
    this.selectedDocument = doc.documentTitle;
    this.displayDocument = true;
}
}


viewDocument(id: number) {
        //this.loadingService.show();

        let doc = this.supportingDocuments.find(x => x.documentId == id);
        
        if (doc != null) {

        
            this.binaryFile = doc.fileData;
            this.selectedDocument = doc.documentTitle;
            this.displayDocument = true;
        }
        //this.loadingService.hide(1000);

    }

    DownloadDocument(id: number) {
        let doc = this.supportingDocuments.find(x => x.documentId == id);
        
            if (doc != null) {
                this.pdfFile = doc.fileData;
                this.pdfFileName = doc.documentTitle;
                this.myDocExtention = doc.fileExtension;
                var byteString = atob(this.pdfFile);
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                var bb = new Blob([ab]);

                if (this.myDocExtention == 'jpg' || this.myDocExtention == 'jpeg') {
                try {
                    var file = new File([bb], this.pdfFileName + '.jpg', { type: 'image/jpg' });
                    saveAs(file);
                } catch (err) {
                    var saveFileAsBlob = new Blob([bb],  { type: 'image/jpg' });
                    window.navigator.msSaveBlob(saveFileAsBlob, this.pdfFileName + '.jpg');
                }
            }
            if (this.myDocExtention == 'png' || this.myDocExtention == 'png') {  
                try {
                    var file = new File([bb], this.pdfFileName + '.png', { type: 'image/png' });
                    saveAs(file);
                } catch (err) {
                    var saveFileAsBlob = new Blob([bb],  { type: 'image/png' });
                    window.navigator.msSaveBlob(saveFileAsBlob, this.pdfFileName + '.png');
                }
            }
            if (this.myDocExtention == 'pdf' || this.myDocExtention == '.pdf') { 
                try {
                    var file = new File([bb], this.pdfFileName + '.pdf', { type: 'application/pdf' });
                    saveAs(file);
                } catch (err) {
                    var saveFileAsBlob = new Blob([bb],  { type: 'application/pdf' });
                    window.navigator.msSaveBlob(saveFileAsBlob, this.pdfFileName + '.pdf');
                }
            }
            if (this.myDocExtention == 'xls' || this.myDocExtention == 'xlsx') {
                try {
                    var file = new File([bb], this.pdfFileName + '.xlsx', { type: 'application/vnd.ms-excel' });
                    saveAs(file);
                } catch (err) {
                    var saveFileAsBlob = new Blob([bb],  { type: 'application/vnd.ms-excel' });
                    window.navigator.msSaveBlob(saveFileAsBlob, this.pdfFileName + '.xlsx');
                }
            }
            if (this.myDocExtention == 'doc' || this.myDocExtention == 'docx') {
                try {
                    var file = new File([bb], this.pdfFileName + '.doc', { type: 'application/msword' });
                    saveAs(file);
                } catch (err) {
                    var saveFileAsBlob = new Blob([bb],  { type: 'application/msword' });
                    window.navigator.msSaveBlob(saveFileAsBlob, this.pdfFileName + '.doc');
                }
            }

            }
      
    }


getSupportingDocuments(id) {

  this.collateralService.getCollateralDocument(id).subscribe((response: any) => {
      this.supportingDocuments = response.result;
      ////console.log('documents..', response.result);
  });
}

getCollaterTempItemPolicies(id) {
  this.collateralService.getItemPolicyList(id).subscribe((response: any) => {
      this.insurancePolicies = response.result;
      ////console.log('insurancePolicies..', response.result);
  });
}

}
